var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M8.35547 7H3.35547V17H8.35547V7ZM2.35547 6V18H9.35547V6H2.35547Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M15.3555 7H10.3555V17H15.3555V7ZM9.35547 6V18H16.3555V6H9.35547Z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M22.3555 7H17.3555V17H22.3555V7ZM16.3555 6V18H23.3555V6H16.3555Z","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
